import script from "./TheChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TheChart.vue?vue&type=script&setup=true&lang=js"

import "./TheChart.vue?vue&type=style&index=0&id=a72b1a2a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a72b1a2a"]])

export default __exports__